import { TFunction } from 'react-i18next';

import { DurationType, DurationValue } from 'types/Search/form';

import { InputState } from '../types';

const weekRegex = /^(\d+)w$/;

export function buildSelectionFromValue(
    value: DurationValue,
    t: TFunction
): string | null {
    switch (value.type) {
        case DurationType.Empty:
            return null;
        case DurationType.Exact:
            return t('TRANS-exact');
        case DurationType.Week:
            return t('TRANS-week[i]', {
                count: value.amount,
                postProcess: 'interval',
            });
        case DurationType.Day:
            return t('TRANS-day[i]', {
                count: value.amount,
                postProcess: 'interval',
            });
        case DurationType.Range:
            return `${value.min} - ${t('TRANS-day[i]', {
                count: value.max,
                postProcess: 'interval',
            })}`;
    }
}
export function buildInputStateFromValue(value: DurationValue): InputState {
    switch (value.type) {
        case DurationType.Day:
            return {
                selectedOption: DurationType.Day,
                days: value.amount.toString(),
                min: '',
                max: '',
            };
        case DurationType.Range:
            return {
                selectedOption: DurationType.Range,
                days: '',
                min: value.min.toString(),
                max: value.max.toString(),
            };
        case DurationType.Exact:
            return {
                selectedOption: DurationType.Exact,
                days: '',
                min: '',
                max: '',
            };
        case DurationType.Week:
            return {
                selectedOption: `${value.amount}w`,
                days: '',
                min: '',
                max: '',
            };
        case DurationType.Empty:
            return {
                selectedOption: '',
                days: '',
                min: '',
                max: '',
            };
    }
}
export function buildValueFromInputState(input: InputState): DurationValue {
    switch (input.selectedOption) {
        case DurationType.Day:
            return {
                type: DurationType.Day,
                amount: parseInt(input.days),
            };
        case DurationType.Range:
            const min = parseInt(input.min);
            const max = parseInt(input.max);
            if (min === max) {
                // fallback to day if min and max are same
                return {
                    type: DurationType.Day,
                    amount: min,
                };
            }
            // ensure correct format
            return {
                type: DurationType.Range,
                min: Math.min(min, max),
                max: Math.max(min, max),
            };
        case DurationType.Exact:
            return {
                type: DurationType.Exact,
            };
        default:
            const weekMatch = weekRegex.exec(input.selectedOption);
            if (weekMatch) {
                return {
                    type: DurationType.Week,
                    amount: parseInt(weekMatch[1]),
                };
            }
            return {
                type: DurationType.Empty,
            };
    }
}
